import React from 'react'

import { Route, Routes } from "react-router-dom"

import WarehousingCreateScreen from "screens/App/CRM/Warehousing/WarehousingCreateScreen"
import WarehousingDetailScreen from "screens/App/CRM/Warehousing/WarehousingDetailScreen"
import WarehousingEditScreen from "screens/App/CRM/Warehousing/WarehousingEditScreen"
import WarehousingListScreen from "screens/App/CRM/Warehousing/WarehousingListScreen"

import NotFoundScreen from "screens/NotFoundScreen"

const WarehousingRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<WarehousingCreateScreen />} />

            <Route path="list" element={<WarehousingListScreen />} />

            <Route path=":id/detail" element={<WarehousingDetailScreen />} />

            <Route path=":id/edit" element={<WarehousingEditScreen />} />

            <Route path="*" element={<NotFoundScreen />} />

        </Routes>
    )
}

export default WarehousingRouter